module.exports = __webpack_public_path__ + "static/media/bg-02.b65d7af0.png";